import { saveLastViewedEntityToApiService } from '@services/apiService';
import { RELOAD_LISTING_CLICKED_SUCCESS, VIEW_LISTING_CLICKED } from '@redux/modules/listing';
import { SELECT_AGENT_SUCCESS } from '@redux/modules/agent';
import { SELECT_OFFICE_SUCCESS } from '@redux/modules/office';
import {
  ASYNC_START,
  ASYNC_END,
  DOMAIN_AUTHENTICATION,
  SET_ERRORS,
  LOGIN,
} from './constants/ActionTypes';

const isPromise = value => Boolean(value && typeof value.then === 'function');

const promiseMiddleware = store => next => action => {
  if (!isPromise(action.payload)) return next(action);

  store.dispatch({
    type: ASYNC_START,
    subtype: action.type,
  });

  return action.payload.then(res => {
    store.dispatch({
      type: ASYNC_END,
      promise: res,
    });
    store.dispatch({ ...action, payload: res });
  }).catch(error => {
    store.dispatch({ type: ASYNC_END, promise: error });
    store.dispatch({
      ...action,
      error: true,
      payload: error,
      type: SET_ERRORS,
    });
  });
};

const localStorageMiddleware = () => next => action => {
  const storageWhiteList = [DOMAIN_AUTHENTICATION, LOGIN];
  if (!storageWhiteList.includes(action.type)) return next(action);

  // agent.setToken(action.error ? null : action.payload.access_token); // not implemented
  return next(action);
};

/*
  Use [saveLastViewedEntity] middleware to keep track of the last viewed entity, and to save this to various modules where this data is required.
  This method represent a workaround for modules where accessing the redux store directly is not possible/recommended due to cyclic dependencies (e.g. apiService).
*/
const saveLastViewedEntity = () => next => action => {
  let entity;
  switch (action.type) {
    case VIEW_LISTING_CLICKED:
      entity = {
        type: 'listing',
        id: action.data.ListingID,
      };
      saveLastViewedEntityToApiService(entity);
      break;

    case RELOAD_LISTING_CLICKED_SUCCESS:
      entity = {
        type: 'listing',
        id: action.payload.listingSearchResults.ListingID,
      };
      saveLastViewedEntityToApiService(entity);
      break;

    case SELECT_AGENT_SUCCESS:
      entity = {
        type: 'agent',
        id: action.payload.fullAgent.UniqueID,
      };
      saveLastViewedEntityToApiService(entity);
      break;

    case SELECT_OFFICE_SUCCESS:
      entity = {
        type: 'office',
        id: action.payload.UniqueID,
      };
      saveLastViewedEntityToApiService(entity);
      break;

    default: break;
  }
  return next(action);
};

export { promiseMiddleware, localStorageMiddleware, saveLastViewedEntity };
